<template>
  <div v-if="popupImage.id > 0">
    <div class="fixed-bottom" :class="bannerClass" v-show="isShowBanner">
      <div class="pc-popup">
        <a :href="popupImage.link" target="_blank" style="height: auto" @click="gioTrackingBm(popupImage.link)">
          <img :src="popupImage.imageUrl" style="width: 100%" />
        </a>
        <img
          class="close-popup"
          @click="showIcon()"
          src="https://resource.rcclchina.com.cn/cruiseSearch/popup/popup-close-image1.png"
        />
      </div>
    </div>
    <div
      class="fixed-icon"
      :class="iconClass"
      v-show="!isShowBanner"
      @click="showBanner()"
    >
      <img class="pc-popup-image" :src="popupImage.iconImage" />
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {gioAdsTracking, gioTracking} from "@/utilities/tools";
export default {
  name: "CruiseSearchBottomBanner",
  data() {
    return {
      isShowBanner: true,
      popupBannerAutoHide: null,
      bannerClass: {},
      iconClass: {},
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      const cookie = Cookies.get("BOTTOM_BANNER_COOKIE");
      if (cookie == 1) {
        this.isShowBanner = false;
        this.showIcon();
      } else {
        Cookies.set("BOTTOM_BANNER_COOKIE", "1", { expires: 1 });
        const countDown = this.popupImage.countDown;
        if (!isNaN(countDown)) {
          this.popupBannerAutoHide = setTimeout(() => {
            this.showIcon();
          }, countDown * 1000);
        }
      }
    },
    showIcon() {
      this.bannerClass = {
        animated: true,
        bounceOutLeft: true,
      };
      setTimeout(() => {
        this.isShowBanner = false;
        this.iconClass = {
          animated: true,
          bounceInLeft: true,
        };
        this.bannerClass = {};
      }, 1000);
    },
    showBanner() {
      if (this.popupBannerAutoHide) {
        clearTimeout(this.popupBannerAutoHide);
      }
      this.iconClass = {
        animated: true,
        bounceOutLeft: true,
      };
      setTimeout(() => {
        this.isShowBanner = true;
        this.bannerClass = {
          animated: true,
          bounceInLeft: true,
        };
        this.iconClass = {};
      }, 1000);
    },
		gioTrackingBm (link) {
      gioTracking('track', 'evt_ButtonClicked',{
        'btnType': `CruiseSearchBannerBottomLeft`
      })
			gioAdsTracking({
				'adsType': 'bm',
				'desUrl': link
			})
		}
  },
  computed: {
    popupImage() {
      const searchPage = this.$store.state.cruise.cruiseSearchPage;
      if (!searchPage || !searchPage.pcPopupImage) return {};
      return searchPage.pcPopupImage;
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
.fixed-bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1111;
  min-width: 1200px;
  .pc-popup {
    position: relative;
    a {
      display: block;
      width: 100%;
      height: 120px;
      background-position: center;
    }
  }
  .close-popup {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 13px;
    cursor: pointer;
    color: white;
    background-color: #000f1c;
    text-align: center;
  }
}

.fixed-bottom.active {
  display: block;
}

.fixed-icon {
  position: fixed;
  bottom: 30px;
  left: 0;
  z-index: 999;
  cursor: pointer;
}

.fixed-icon.active {
  display: block;
}
</style>
